<loading [isLoading]="isLoading" [success]="loadingSuccess"></loading>

<div #setContentsContainer class="items-center md:items-start justify-center flex flex-col md:flex-row gap-4">
    <div #setInfoContainer class="pt-[5px] relative">
        @if (magicSet) {
            <magic-set-info 
                [magicSet]="magicSet!" 
                [childSets]="childSets" 
            [items]="previewItems!"></magic-set-info>
        }
    </div>
    @if (previewItems?.visibleItems) {
        <virtual-grid [items]="previewItems!"></virtual-grid>
    }
</div>